// extracted by mini-css-extract-plugin
export default {"container":"roundOpening_container__Xx15X","section":"roundOpening_section__vmnf5"};